// import API from '../../api/api';
import PropTypes from "prop-types";
import UsersTable from "./UsersTable";
import { Link } from "react-router-dom";
import Tab from "@material-ui/core/Tab";
import React, { Component } from "react";
import Tabs from "@material-ui/core/Tabs";
import AppBar from "@material-ui/core/AppBar";
import UserCreationForm from "./UserCreationForm";
import "../../styles/css/users/CompanyUserMgt.css";
import UsersPendingTable from "./UsersPendingTable";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Container, Row, Col } from "bootstrap-4-react";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

const userRole = localStorage.getItem("userRole");
const userRoleId = localStorage.getItem("userRoleId");

function TabContainer(props) {
  return <Typography component="div">{props.children}</Typography>;
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#ffffff",
    boxShadow: "none",
    color: "#606060",
  },
  indicator: {
    backgroundColor: "#00aeef",
  },
  selected: {
    color: "#00aeef",
  },
});

class CompanyUserMgt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableKey: "",
      value: 0,
    };
  }

  setTableKey = (userId) => {
    this.setState({ tableKey: userId });
  };

  tabsHandleChange = (event, value) => {
    this.setState({
      value,
    });
  };

  render() {
    const { value } = this.state;
    const { classes } = this.props;

    return (
      <div className="">
        <Container className="breadCrubmContainerDashboard">
          <div className="breadCrumb">
            <Link to="/" className="prevLinks">
              Dashboard
            </Link>
            <span>&nbsp;&gt;&nbsp;</span>
            <span className="currLink">Manage users</span>
          </div>
        </Container>
        <Container>
          <Row>
            <Col>
              <div className="headerCardRoot">
                <div className="headerCardMain cardHeading">
                  <div className="headerCardTitle">
                    <span>Manage users</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          {/* =============================================================  */}
          {/* =============== user creation form for admins ===============  */}
          {/* =============================================================  */}
          {userRoleId === "1" || userRoleId === "2" || userRoleId === "4" ? (
            <Row>
              <Col>
                <UserCreationForm newId={this.setTableKey} />
              </Col>
            </Row>
          ) : null}
          <Row>
            {userRole !== "Admin" ? (
              <Col>
                <div className="activeUsersDiv">
                  <span>Active users</span>
                  <ArrowDropDownIcon />
                </div>
                <UsersTable key={this.state.tableKey} />
              </Col>
            ) : (
              <Col className="AdminTables">
                <div className={`${classes.root} mainTabsDiv projectsView`}>
                  <AppBar position="static" className={classes.root}>
                    <Tabs
                      classes={{ indicator: classes.indicator }}
                      value={value}
                      onChange={this.tabsHandleChange}
                    >
                      <Tab
                        classes={{ selected: classes.selected }}
                        className="tableTabs"
                        label="Approved"
                      />
                      <Tab
                        classes={{ selected: classes.selected }}
                        className="tableTabs"
                        label="Pending"
                      />
                    </Tabs>
                  </AppBar>
                  {value === 0 && (
                    <TabContainer>
                      <UsersTable key={this.state.tableKey} />
                    </TabContainer>
                  )}
                  {value === 1 && (
                    <TabContainer>
                      <UsersPendingTable key={this.state.tableKey} />
                    </TabContainer>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    );
  }
}

CompanyUserMgt.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CompanyUserMgt);



// WEBPACK FOOTER //
// ./src/pages/Users/CompanyUserMgt.js